import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'wr-share-protocol-pdf-page',
  templateUrl: './share-protocol-pdf-page.component.html',
  styleUrls: ['./share-protocol-pdf-page.component.scss'],
})
export class ShareProtocolPdfPageComponent {
  pdfUrl: SafeResourceUrl | undefined;
  pdfLoadFailed = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
  ) {
    route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.loadPdf(id);
      } else {
        this.pdfLoadFailed = true;
      }
    });
  }

  private loadPdf(shareLinkId: string): void {
    this.http.get(`${environment.apiUrl}/api/protocol/share/${shareLinkId}`, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const fileURL = URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      },
      error: () => {
        this.pdfLoadFailed = true;
      },
    });
  }
}
